<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <span
        @click="toggleArrow"
        v-on="on"
        class="mx-3 topBarItem"
      >
        <b>{{ curUserName}}</b>
        <v-icon v-if="arrowFlag" style="font-size: 1.2rem">mdi-chevron-down</v-icon>
        <v-icon v-else style="font-size: 1.2rem">mdi-chevron-up</v-icon>
      </span>
    </template>
    <v-list>
      <v-list-item class="profile-btn" @click="EditProfile">
        <v-list-item-title>User Profile</v-list-item-title>
      </v-list-item>
      <v-list-item class="profile-btn" @click="UserSubscription">
        <v-list-item-title>Billing</v-list-item-title>
      </v-list-item>
      <v-list-item class="logout-btn" @click="logout">
        <v-list-item-title>Logout</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { MODULE_USER } from '../../store/constant/mutation-types'
import { SETTINGS_PAGE_SUBSCRIPTION, SETTINGS_PAGE_USER_PROFILE } from '../../constant'

export default {
  name: 'UserTopMenu',
  data() {
    return {
      arrowFlag: true
    }
  },
  mounted() {
    const curUserData = JSON.parse(localStorage.getItem('curUserData'))
    this.$store.commit('user/set', {
      type: 'curUserData',
      val: curUserData
    })
    this.curUserName = curUserData.firstName + ' ' + curUserData.lastName
  },
  computed: {
    curUserName: {
      get() {
        const currentData = this.$store.getters[`${MODULE_USER}/user`]
        return currentData.firstName + ' ' + currentData.lastName
      },
      set() {}
    },
    getUserRight() {
      return right => this.$store.getters['user/getUserRight'](right)
    }
  },
  methods: {
    toggleArrow() {
      this.arrowFlag = !this.arrowFlag
    },
    logout() {
      this.$store.dispatch(`${MODULE_USER}/logout`).then(() => {
        document.location.href = '/'
      })
    },
    EditProfile: function () {
      this.$router.push({
        name: 'UserSettings'
      }, () => {
        this.$store.dispatch('setSettingsPageSection', SETTINGS_PAGE_USER_PROFILE)
      })
    },
    UserSubscription: function () {
      this.$router.push({
        name: 'UserSettings'
      }, () => {
        this.$store.dispatch('setSettingsPageSection', SETTINGS_PAGE_SUBSCRIPTION)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.profile-btn,
.logout-btn {
  cursor: pointer;
  &:hover {
    background-color: darkgrey;
  }
  .v-list-item__title {
    font-size: 13px;
  }
}
</style>
